import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing } from 'recompose';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { getStaticData } from '../../../../../store/reducers/static-data';
import { mapGoals } from '../../../../../helpers/future-fit/map-goals';
import { withWidgetLoadingHandlers } from '../../../../../components/layout/content/with-native-loading-state';
import { SET_WIDGET_STATE_ASYNC_SUCCESS } from '../../../../../store/reducers/application';

const mapStateToProps = ({ staticData, userAttributes }, { type, attributeName }) => {
  const mapping = staticData?.[type]?.[type];
  const data = userAttributes.generated[attributeName];
  const items = data && mapGoals(data, mapping);

  return {
    items,
    loading: staticData.loading[type] ?? true,
    hasData: !ObjectShim.isEmpty(data),
    hasMapping: Boolean(mapping)
  };
};

export const withData = compose(
  connect(mapStateToProps, { getStaticData }),
  withWidgetLoadingHandlers,
  lifecycle({
    componentDidMount() {
      const { getStaticData, type, hasMapping, setWidgetLoadedState } = this.props;

      if (!hasMapping) {
        const fetchStaticData = async () => await getStaticData(type);
        fetchStaticData().then(setWidgetLoadedState(SET_WIDGET_STATE_ASYNC_SUCCESS, true));
      }
    }
  }),
  branch(({ hasData, loading }) => !hasData || loading, renderNothing)
);
